import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { addModifier } from '../../player.type';
import { StatusEffect } from '../../status-effects.type';

export class WardenTrait extends Trait {
  static baseType = TraitType.Warden;
  static baseTitle = "Warden's Shield";
  static baseText =
    'At the start of every even turn, gain 1 Strength. At the end of every odd turn, gain 1 Armoured.';
  static baseIcon = 'trait';

  type = WardenTrait.baseType;
  title = WardenTrait.baseTitle;
  text = WardenTrait.baseText;
  icon = WardenTrait.baseIcon;

  turn = 0;

  startTurn(): void {
    if (this.turn % 2 === 0) {
      addModifier(this.owner, StatusEffect.Strength, 1);
    } else {
      addModifier(this.owner, StatusEffect.Armoured, 1);
    }
    this.turn++;
  }
}

TraitRegistry.register(WardenTrait.baseType, WardenTrait);
